import React, { useCallback } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import {
  useFormEvents,
  ResetPasswordForm,
  ResetPasswordFormFields,
  ResponsiveContainer,
} from '@lib/common';
import { accountService, AccountForms, FormStatus } from '@lib/state';
import { Typography } from '@material-ui/core';

export const ResetPasswordPage: React.FC = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const email = queryParams.get('email') || '';
  const token = queryParams.get('token') || '';
  const history = useHistory();

  if (!email || !token) {
    history.push('/');
  }
  const submit = ({ password }: ResetPasswordFormFields) => {
    accountService.resetPassword(email, token, password);
  };

  const onRedirectToSignIn = useCallback(() => history.push('/account/signout'), [history]);

  const [{ status, error }, resetFormUI] = useFormEvents(AccountForms.ResetPassword);

  return (
    <ResponsiveContainer>
      <Typography variant="h5" align="center" color="textSecondary" paragraph>
        Reset Password
      </Typography>
      <ResetPasswordForm
        pending={status === FormStatus.Pending}
        success={status === FormStatus.Success}
        error={error}
        onSubmit={submit}
        onResetFeedback={resetFormUI}
        onRedirectToSignIn={onRedirectToSignIn}
      />
    </ResponsiveContainer>
  );
};
